export default {"src":"/_next/static/media/telegram.14b78775.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};